// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@store/MobiusOverrides/Pagination/Pagination";
import constants from "@store/constants";
import { ShipmentsDataViewContext } from "@store/Framework/Store/Greif/Data/Shipments/ShipmentsSelectors";
import updateSearchFields from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/UpdateSearchFields";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;

export interface ShipmentHistoryPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const orderHistoryPaginationStyles: ShipmentHistoryPaginationStyles = {
    pagination: {
        showGoToPage: true,
    },
};

const styles = orderHistoryPaginationStyles;

const ShipmentHistoryPagination = ({ updateSearchFields }: Props) => {
    const shipmentDataView = usePersistentDataView(useContext(ShipmentsDataViewContext));
    const pagination = shipmentDataView.value && shipmentDataView.pagination ? shipmentDataView.pagination : undefined;

    const [shouldScrollToTop, setShouldScrollToTop] = useState(false);
    useEffect(() => {
        if (shouldScrollToTop) {
            window.scrollTo(0, 0);
            setShouldScrollToTop(false);
        }
    }, [pagination?.page]);

    if (!pagination) {
        return null;
    }

    const { totalItemCount, page, pageSize, pageSizeOptions, prevPageUri, nextPageUri } = pagination;
    if (totalItemCount === 0) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        updateSearchFields({
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateSearchFields({
            page: 1,
            pageSize: newPageSize,
        });
    };

    const pageSizeCookieName = "ShipmentHistory-PageSize";

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={totalItemCount}
            currentPage={page}
            resultsPerPage={pageSize}
            resultsPerPageOptions={pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            pageSizeCookie={pageSizeCookieName}
            prevPage={prevPageUri}
            nextPage={nextPageUri}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(ShipmentHistoryPagination),
    definition: {
        displayName: "Pagination",
        group: constants.widgetGroup.shipmentHistory,
        allowedContexts: [""],
    },
};

export default widgetModule;
